// "Single" (cargar_examen_json.py) y "Único" (cargar_examen_pdf.py) son el
// mismo relleno de siempre: "no hay un Tipo A/B real para este examen". No
// aportan nada en la UI, solo ruido -- se tratan como "sin modelo real".
const TYPE_LABELS = {
  test: { num: 1, label: 'Test' },
  'caso practico': { num: 2, label: 'Caso Práctico' },
  case_study: { num: 2, label: 'Caso Práctico' },
  word: { num: 3, label: 'Ofimática' },
};

const hasRealModel = (model) => model && model !== 'Único' && model !== 'Single';
const isIncidencias = (session) => session === 'Incidencias' || session === 'Incidents';

// Construye el título a partir de los campos estructurados que ya devuelve
// el backend (type/model/session) en vez de recortar el `name` crudo: ese
// `name` se generó con plantillas distintas según el script de carga usado
// (algunas en inglés, otras mezclando "Modelo Single" en español), y
// limpiarlo a base de regex nunca cubre todas las variantes históricas.
export const buildExamTitle = (exam, fallbackRawName) => {
  const info = TYPE_LABELS[exam?.type];
  if (!info) return translateExamLabel(fallbackRawName);
  let title = `Ejercicio ${info.num} (${info.label})`;
  if (hasRealModel(exam.model)) title += ` - Modelo ${exam.model}`;
  if (isIncidencias(exam.session)) title += ' (Incidencias)';
  return title;
};

// Orden de los exámenes dentro de una convocatoria: primero los ordinarios, luego los de incidencias; por ejercicio y modelo.
export const examSortKey = (exam) => [
  isIncidencias(exam?.session) ? 1 : 0,
  TYPE_LABELS[exam?.type]?.num ?? 9,
  exam?.model || '',
];

export const compareExams = (a, b) => {
  const ka = examSortKey(a);
  const kb = examSortKey(b);
  for (let i = 0; i < ka.length; i += 1) {
    if (ka[i] < kb[i]) return -1;
    if (ka[i] > kb[i]) return 1;
  }
  return 0;
};

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

// Convocatorias de un mismo año: 'Septiembre 2024' antes que 'Marzo 2024'; las que solo llevan el año, al final.
export const compareConvocatorias = (a, b) =>
  MESES.indexOf((b || '').split(' ')[0].toLowerCase()) - MESES.indexOf((a || '').split(' ')[0].toLowerCase());

// Algunos exámenes antiguos se guardaron con fragmentos en inglés
// ("Exercise 1 (Test)", "Model A (Normal)"...). Esto traduce esos
// fragmentos a español para mostrarlos en cualquier pantalla.
export const translateExamLabel = (rawName) => {
  let n = rawName || '';
  n = n.replace(/Exercise 1 \(Test\)/g, 'Ejercicio 1 - Test');
  n = n.replace(/Exercise 2 \(Case Study\)/g, 'Ejercicio 2 - Caso Práctico');
  n = n.replace(/Exercise 3 \(Word\)/g, 'Ejercicio 3 - Word');
  n = n.replace(/Model Single \(Normal\)/g, '');
  n = n.replace(/Model Single \(Incidents\)/g, 'Incidencias');
  n = n.replace(/Model A \(Normal\)/g, 'Modelo A');
  n = n.replace(/Model A \(Incidents\)/g, 'Modelo A · Incidencias');
  n = n.replace(/Model B \(Normal\)/g, 'Modelo B');
  n = n.replace(/Model B \(Incidents\)/g, 'Modelo B · Incidencias');
  n = n.replace(/^\s*[-·]\s*/, '').replace(/\s*[-·]\s*$/, '');
  n = n.replace(/\s+/g, ' ').replace(/\s+-\s+-\s+/g, ' - ').trim();
  return n || rawName;
};

// 'Generado - Auxilio - test - 2026-06-08 17:23:04' → 'Test · 2026-06-08 17:23'
export const prettifyGeneratedName = (rawName) => {
  const parts = (rawName || '').split(' - ');
  if (parts.length >= 4) {
    const type = parts[2] === 'caso practico' ? 'Caso práctico' : 'Test';
    const ts = parts.slice(3).join(' - ').replace(/:\d{2}$/, '');
    return `${type} · ${ts}`;
  }
  return rawName;
};
